import React from 'react';

/**
 * NeonWordmark — renders "WorldVibe" with each letter lit up like a real neon
 * sign turning on. Letters flicker into view left-to-right with a staggered
 * `animation-delay`. The "World" half glows white; the "Vibe" half glows in
 * the cyan/violet/pink brand gradient.
 *
 * Set `animate={false}` to render the wordmark statically (post-boot state).
 */
const WORLD = 'World'.split('');
const VIBE  = 'Vibe'.split('');

export default function NeonWordmark({
  className = 'font-display font-bold tracking-tight',
  animate = true,
  baseDelayMs = 60,
  startDelayMs = 100,
}) {
  const letterDelay = (i) => (animate ? `${startDelayMs + i * baseDelayMs}ms` : '0ms');
  const letterCls = animate ? 'neon-letter' : 'inline-block';

  return (
    <span className={className} aria-label="WorldVibe">
      {WORLD.map((ch, i) => (
        <span
          key={`w-${i}`}
          className={`${letterCls} text-white`}
          style={{ animationDelay: letterDelay(i), color: '#F8FAFC' }}
          aria-hidden="true"
        >
          {ch}
        </span>
      ))}
      {VIBE.map((ch, i) => (
        <span
          key={`v-${i}`}
          className={letterCls}
          style={{
            animationDelay: letterDelay(WORLD.length + i),
            background: 'linear-gradient(135deg,#22D3EE,#8B5CF6,#EC4899)',
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            color: '#EC4899',           // fallback base color for text-shadow currentColor
            WebkitTextFillColor: 'transparent',
          }}
          aria-hidden="true"
        >
          {ch}
        </span>
      ))}
    </span>
  );
}
